import { isValid, format } from 'date-fns'

export const isoStringToHTMLInput = (
  isoString: string,
  { useTime }: { useTime: boolean }
): string => {
  if (useTime) {
    // in the case of useTime, then timezones play a role in the result.
    // we always show the date localized.
    const date = new Date(isoString)
    const formatted = format(date, `yyyy-MM-dd'T'HH:mm`)

    return formatted
  } else {
    const [d, _t] = isoString.split('T')
    return d ?? ''
  }
}

export const isoStringToDisplayDate = (
  isoString: string,
  { useTime }: { useTime: boolean }
): string => {
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }

  let date = new Date(isoString)
  if (useTime) {
    options.hour = '2-digit'
    options.minute = '2-digit'
  } else {
    options.timeZone = 'UTC'
    const [d] = isoString.split('T')
    if (!d) return ''
    date = new Date(d)
  }

  // Use 'en-GB' locale for dd-mm-YYYY format
  const formatter = new Intl.DateTimeFormat('en-GB', options)
  const formatted = formatter.format(date)

  return formatted
}

export const HTMLInputToIsoString = (inputValue: string | number) => {
  const date = new Date(`${inputValue}`)
  if (!isValid(date)) return ''
  return date.toISOString()
}

export const dateToMktDateString = (date: Date) =>
  `${date.toLocaleString('default', {
    month: 'long',
    timeZone: 'UTC',
  })} ${date.getUTCDate()}, ${date.getUTCFullYear()}`

export const getDateBlockPlaceholder = ({ useTime }: { useTime: boolean }) =>
  useTime ? 'dd/mm/yyyy, --:--' : 'dd/mm/yyyy'
